import { createFileRoute } from '@tanstack/react-router';
import { HostProductPlaceholder } from '@/lib/nav/HostProductPlaceholder';

export const Route = createFileRoute('/channels')({
  component: ChannelsPlaceholder,
});

// Seam route (spec §5.11, plan §9b) — post-launch, flags.hostProducts +
// entity.namibia_ltd. See HostProductPlaceholder's header comment.
function ChannelsPlaceholder() {
  return <HostProductPlaceholder title="Channel sync" />;
}
